import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import './index.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import registerServiceWorker from './registerServiceWorker';
import App from './containers/App';
import configHistory from './configHistory';
import { Provider } from 'react-redux'
import { createStore } from 'redux'
import combineReducers from './reducer/'
import StateLoader from './reducer/StateLoader'
//const   baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
// import WrappedLogin2 from './Login2'



const stateloader = new StateLoader();
const store = createStore(combineReducers, stateloader.loadState());
store.subscribe(() => {
  stateloader.saveState(store.getState());
  // console.log("Update Store:", store.getState());
})
const history = configHistory()
const rootElement = document.getElementById('root');


// class Condition1 extends React.Component {
// 	render() {
// 		return (
// 			<div>Condition 1</div>
// 		);
// 	}
// }


ReactDOM.render(
 <Provider store={store}>
   <Router history={history}>
     <App />
   </Router>
  </Provider>,


//  // <WrappedLogin2 />,
  rootElement);

registerServiceWorker();
